import { render, staticRenderFns } from "./SoldProductsChart.vue?vue&type=template&id=3db002fb"
import script from "./SoldProductsChart.vue?vue&type=script&lang=js"
export * from "./SoldProductsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports